import { useNavigate } from "react-router-dom";
import routes from "../../../Constants/routes";
import { useTranslation } from "react-i18next";
import { VossVersionStatusText } from "../../../Constants/VOSS/vossVersionStatus";

export function PriceAdjustmentPackagesTable({ packages }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const navigateToEdit = (p) => {
        const params = new URLSearchParams();
        params.append("Id", p.id);
        params.append("VersionId", p.versionId);
        navigate({
            pathname: routes.vossPriceAdjustmentsEdit,
            search: params.toString()
        });
    }

    return <table className="table table-stripe skynet-table-no-divider table-active">
        <thead>
            <tr>
                <th>{t('common.name')}</th>
                <th>{t('common.status')}</th>
            </tr>
        </thead>
        <tbody>
            {packages?.map((p) => {
                return <tr key={p.id} onClick={() => navigateToEdit(p)}>
                    <td>{p.name}</td>
                    <td>{VossVersionStatusText[p.status]}</td>
                </tr>
            })}
        </tbody>
    </table>
}